import React, { useContext, useEffect, useState } from 'react';
import ContentApp from '../../../../components/ContentApp';
import { WelletContext } from '../../../../context/WelletContext';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setReservation } from '../../../../actions/reservationActions';
import { CircleSpinner } from 'react-spinners-kit';
import { fetchProductTransfer } from '../../../../services/transfer/transferService';
import SearchSummaryCard from '../../../../components/TripSummary/TripSummary';
import PrivateTransportCard from '../../../../components/PrivateTransportCard/PrivateTransportCard';
import Header from '../../../../components/Common/Header/Header';

const TransferProductSelector = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(null);
  const transferType = useSelector((state) => state.reservation.transferType);

  const reservation = useSelector((state) => state.reservation);
  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: reservation.showId,
          lang: language,
          details: false,
          reservationType: 'RESTAURANT',
          images: false,
          videos: false,
          IsFeature: false,
        },
      });

      setShow(result.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // const getTransferTypeLabel = (type) => {
  //   switch (type) {
  //     case 'ONEWAY':
  //       return t('oneWay');
  //     case 'ROUNDTRIP':
  //       return t('roundTrip');
  //     default:
  //       return '';
  //   }
  // };

  const getProducts = async () => {
    try {
      const result = await fetchProductTransfer(
        welletContext,
        reservation.showId,
        reservation?.transferFrom?.zoneId,
        reservation?.transferTo?.zoneId,
        reservation?.paxs,
        reservation?.transferType,
        language,
      );

      setProducts(result.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleIncrement = (id) => {
    const index = products.findIndex((p) => p.id === id);
    const product = products[index];

    if (product.stock && product.stock === product.quantity) return;

    let newProducts = [...products];

    newProducts[index].disabled = false;
    newProducts[index].quantity = 1;
  };

  const handleOnReserve = (productId) => {
    handleIncrement(productId);
    const reservationInfo = setReservationInfo();
    dispatch(setReservation(reservationInfo));

    history.push({
      pathname: '/complete-transfer-details',
    });
  };

  const setReservationInfo = () => {
    let selectedProducts = products.filter((product) => product.quantity > 0);
    let finalProducts = products
      .filter((product) => product.quantity > 0)
      .map((product) => ({
        id: product.id,
        quantity: product.quantity,
        extraPaxs: 0,
        specialType: product.specialType,
        paxs: product.pax * product.quantity,
        imageUrl: product.images?.[0] || null,
      }));

    const totalAmount = products
      .filter((p) => p.quantity > 0)
      .reduce((sum, p) => sum + p.prices.price * p.quantity, 0);

    return {
      ...reservation,
      showId: reservation.showId,
      showName: show.name,
      products: finalProducts,
      hasTransportation: false,
      totalAmount,
      imageUrl: selectedProducts[0]?.images?.[0] || null,
    };
  };

  useEffect(() => {
    if (reservation) {
      getShow();
      getProducts();
    }
  }, []);

  return (
    <>
      {loading || !show ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header />

          <ContentApp>
            <div className='fw-600'>Transfers disponibles</div>
            <div
              className='font-tiny text-tertiary mt-1'
              dangerouslySetInnerHTML={{
                __html: t('transfer.findTransfers_' + transferType, {
                  from: reservation?.transferFrom?.label,
                  to: reservation?.transferTo?.label,
                }),
              }}
            >
            </div>

            {/* <SearchSummaryCard
              from={reservation?.transferFrom?.label}
              to={reservation?.transferTo?.label}
              passengers={reservation.paxs}
              tripType={getTransferTypeLabel(transferType)}
            /> */}
            <div className='mt-4 pt-2'>
              {products.map((p) => (
                <PrivateTransportCard
                  key={p.id}
                  product={p}
                  onReserve={() => handleOnReserve(p.id)}
                />
              ))}
            </div>
          </ContentApp>
        </>
      )}
    </>
  );
};

export default TransferProductSelector;
